import { Controller } from "@hotwired/stimulus"

// One expandable NavList item. The sub nav animates on max-height, so the
// controller measures it and hands the height to the CSS through the custom
// property upstream uses; `inert` keeps a collapsed list out of the tab order.
export default class extends Controller {
  static targets = ["button", "subNav"]
  static values = { expanded: Boolean }

  connect() {
    this.measure()
    this.resizeObserver = new ResizeObserver(() => this.measure())
    this.resizeObserver.observe(this.subNavTarget)
  }

  disconnect() {
    this.resizeObserver.disconnect()
  }

  toggle() {
    this.expandedValue = !this.expandedValue
  }

  expandedValueChanged(expanded) {
    this.buttonTarget.setAttribute("aria-expanded", String(expanded))
    this.element.classList.toggle("NavList__item--expanded", expanded)
    this.subNavTarget.classList.toggle("NavList__subNav--expanded", expanded)
    this.subNavTarget.toggleAttribute("inert", !expanded)
    if (expanded) this.subNavTarget.removeAttribute("aria-hidden")
    else this.subNavTarget.setAttribute("aria-hidden", "true")
    this.measure()
  }

  // Ancestors must grow too, or an opened grandchild is clipped by its parent.
  measure() {
    let list = this.subNavTarget
    while (list) {
      list.style.setProperty("--brand-NavList-subNav-height", `${list.scrollHeight}px`)
      list = list.parentElement?.closest(".NavList__subNav") ?? null
    }
  }
}
